import { render, staticRenderFns } from "./salon_detail.vue?vue&type=template&id=4ad7546a&scoped=true"
import script from "./salon_detail.vue?vue&type=script&lang=js"
export * from "./salon_detail.vue?vue&type=script&lang=js"
import style0 from "./salon_detail.vue?vue&type=style&index=0&id=4ad7546a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7546a",
  null
  
)

export default component.exports